import React, { createContext, useContext } from 'react';
import type { ReactNode } from 'react';
import { createMiddleman, getEnvBaseUrl } from './factory';

// Create the context
const MiddlemanContext = createContext<any>(null);

let currentMiddlemanInstance: any = null;

export const MiddlemanProvider = ({ children, baseUrl }: { children: ReactNode; baseUrl?: string; }) => {
  const finalBaseUrl = baseUrl || getEnvBaseUrl();
  const middleman = createMiddleman(finalBaseUrl);
  currentMiddlemanInstance = middleman;
  if ((import.meta as any)?.env?.MODE === 'development') {
    console.log('MiddlemanProvider: Created instance with baseUrl:', finalBaseUrl);
  }
  return (
    <MiddlemanContext.Provider value={middleman}>
      {children}
    </MiddlemanContext.Provider>
  );
};

export const useMiddleman = () => {
  const middleman = useContext(MiddlemanContext);
  if (!middleman) {
    if ((import.meta as any)?.env?.MODE === 'development') {
      console.warn('useMiddleman: No Provider found in tree, falling back to env config');
    }
    return createMiddleman(getEnvBaseUrl());
  }
  return middleman;
};

export const getCurrentMiddleman = () => {
  if (currentMiddlemanInstance) return currentMiddlemanInstance;
  return createMiddleman(getEnvBaseUrl());
};

export default MiddlemanContext;

